/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import Helper from "../utils/Helper";
import _ from "underscore";

export const getOrderID = order => (order && order.id ? order.id : null);
export const getOrderStatusCode = order =>
  order && order.status && order.status.code ? order.status.code : null;
export const getOrderStatusName = order =>
  order && order.status && order.status.name ? order.status.name : null;
export const getOrderNumber = order =>
  order && order.number ? order.number : null;
export const getOrderTable = order =>
  order && order.table ? order.table : null;
export const getOrderTableCode = order =>
  order && order.table && order.table.code ? order.table.code : null;
export const getOrderStall = order =>
  order && order.stall && order.stall.items ? order.stall.items : null;
export const getOrderRemark = order =>
  order && order.remark ? order.remark : null;
export const getOrderTotal = order =>
  order && order.total ? order.total : null;
export const getOrderAttributeIsPayable = order =>
  order && order.attribute && order.attribute.is_payable
    ? order.attribute.is_payable
    : false;
export const getOrderAttributeIsQueued = order =>
  order && order.attribute && order.attribute.is_queued
    ? order.attribute.is_queued
    : false;
export const getOrderAttributeIsRefreshable = order =>
  order && order.attribute && order.attribute.is_refreshable
    ? order.attribute.is_refreshable
    : false;
export const getOrderCurrencySymbol = order =>
  order && order.currency && order.currency.symbol
    ? order.currency.symbol
    : null;
export const getOrderAttributeIsCancellable = order =>
  order && order.attribute && order.attribute.is_cancellable
    ? order.attribute.is_cancellable
    : false;
export const getOrderCheckoutDateTimeRelative = order =>
  order && order.checkout_datetime && order.checkout_datetime.relative
    ? order.checkout_datetime.relative
    : "";
export const getOrderPaymentGatewayItems = order =>
  order &&
  order.payment &&
  order.payment.gateway &&
  !_.isEmpty(order.payment.gateway.items)
    ? order.payment.gateway.items
    : null;
export const getOrderPaymentTotal = order =>
  order && order.total && order.total.final
    ? getOrderCurrencySymbol(order) +
      " " +
      Helper.formatPriceNumber(order.total.final)
    : getOrderCurrencySymbol(order) + " 0.0";
export const getOrderBalancePaymentTotal = order =>
  order &&
  order.payment &&
  order.payment.balance &&
  order.payment.balance.value > 0 &&
  order.payment.balance.text
    ? order.payment.balance.text
    : null;
export const getOrderSummaryItem = order =>
  order && order.summary && order.summary.items ? order.summary.items : [];

// total
export const getOrderTotalQuantity = total =>
  total && total.quantity ? total.quantity : null;
export const getOrderTotalFinal = total =>
  total && total.final
    ? Helper.formatPriceNumber(total.final)
    : Helper.formatPriceNumber(0);

// payment
export const getOrderPaymentObject = current =>
  current && current.payment ? current.payment : null;
export const getOrderPaymentAmount = current =>
  current && current.amount
    ? Helper.formatPriceNumber(current.amount)
    : Helper.formatPriceNumber(0);
export const getOrderPaymentGatewayCode = current =>
  current && current.gateway && current.gateway.code
    ? current.gateway.code
    : null;
export const getOrderPaymentGatewayName = current =>
  current && current.gateway && current.gateway.name
    ? current.gateway.name
    : null;
export const getOrderPaymentToken = current =>
  current && current.token ? current.token : null;
export const getOrderPaymentID = current =>
  current && current.id ? current.id : null;
export const getOrderPaymentData = current =>
  current && current.data ? current.data : null;
export const getOrderPaymentWalletToken = payment =>
  payment && payment.data && payment.data.wallet_token
    ? payment.data.wallet_token
    : null;



// WEBPACK FOOTER //
// ./src/selectors/order.js